"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SidebarLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _typography = _interopRequireDefault(require("../typography"));

var _sidebarText = _interopRequireDefault(require("./sidebar-text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return {
    item: {
      overflow: 'hidden',
      padding: 0
    },
    link: {
      borderLeft: '2px solid transparent',
      color: palette.text.primary,
      display: 'block',
      flex: 1,
      textDecoration: 'none',
      '&:hover': {
        background: palette.action.hover
      }
    },
    linkActive: {
      color: palette.primary.main,
      borderColor: palette.primary.main,
      fontWeight: 500
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


var SidebarLink = _react.default.forwardRef(function SidebarLink(props, ref) {
  var classes = props.classes,
      component = props.component,
      icon = props.icon,
      isActive = props.isActive,
      padded = props.padded,
      text = props.text,
      SidebarTextProps = props.SidebarTextProps,
      rest = _objectWithoutProperties(props, ["classes", "component", "icon", "isActive", "padded", "text", "SidebarTextProps"]);

  var iconColor = isActive ? 'primary' : 'action';
  var linkClasses = (0, _classnames2.default)(classes.link, _defineProperty({}, classes.linkActive, isActive));
  return _react.default.createElement(_ListItem.default, {
    disableGutters: true,
    classes: {
      root: classes.item
    },
    ref: ref,
    component: "li",
    button: true
  }, _react.default.createElement(_typography.default, _extends({
    component: component,
    className: linkClasses
  }, rest), _react.default.createElement(_sidebarText.default, _extends({
    icon: icon,
    iconColor: iconColor,
    padded: padded,
    text: text
  }, SidebarTextProps))));
});

exports.SidebarLink = SidebarLink;
process.env.NODE_ENV !== "production" ? SidebarLink.propTypes = {
  classes: _propTypes.default.object.isRequired,
  text: _propTypes.default.string.isRequired,
  SidebarTextProps: _propTypes.default.object,
  component: _propTypes.default.elementType,
  icon: _propTypes.default.elementType,
  isActive: _propTypes.default.bool,
  padded: _propTypes.default.bool
} : void 0;
SidebarLink.defaultProps = {
  SidebarTextProps: null,
  component: 'a',
  icon: null,
  isActive: false,
  padded: false
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'SidebarLink'
})(SidebarLink);

exports.default = _default;